export default "__VITE_PUBLIC_ASSET__78eebc0b__"